module.exports = __webpack_public_path__ + "7413b4e2cda45b7413c74f55fef5aa3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop_goods_3.jpg
// module id = 209
// module chunks = 1